export default "__VITE_ASSET__oBKZj5QN__"